import { useActivatePluginMutation } from 'api/siteApi';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'sonner';
import { isInIframe } from 'utils/proxyUtils';
import { setShowLogin, setShowRegister } from '../store/userSlice';

export const usePluginActivationRedirect = () => {
  const dispatch = useDispatch();
  const activationCallback = new URL(
    window.location.toString()
  ).searchParams.get('activation_callback');
  const pageRedirect = new URL(window.location.toString()).searchParams.get(
    'page_redirect'
  );

  const siteUrl = new URL(window.location.toString()).searchParams.get(
    'site_url'
  );

  const showCollabExperience = activationCallback && !isInIframe();

  // Execute the query
  const [activatePlugin, { isLoading: isUpdating }] =
    useActivatePluginMutation();

  const handlePluginActivation = useCallback(async () => {
    if (activationCallback) {
      try {
        const data = { url: siteUrl ? siteUrl : activationCallback };
        const response = await activatePlugin(data).unwrap();
        if (response.status) {
          const activateLicenseData = response.data;
          const activation_callback = atob(activationCallback);
          const redirect_url = `admin.php?page=${pageRedirect}&`;
          if (pageRedirect) {
            const url = `${activation_callback}/wp-admin/${redirect_url}wpf_site_id=${activateLicenseData.wpf_site_id}&atarim_response=${activateLicenseData.wpf_license}&site_id=${activateLicenseData?.site_id}`;
            dispatch(setShowLogin(false));
            dispatch(setShowRegister(false));
            window.location.replace(url);
            // window.location.href = url;
          }
        }
      } catch (error) {
        toast.error('Error activating plugin');
        console.error('Error activating plugin:', error);
      }
    }
  }, [activationCallback, siteUrl, activatePlugin, pageRedirect, dispatch]);

  const url = new URL(window.location.href);
  const handleCloseActivationLogin = useCallback(() => {
    url.searchParams.delete('activation_callback');
    url.searchParams.delete('page_redirect');
    url.searchParams.delete('site_url');
    url.searchParams.delete('atarimCollab');
    url.searchParams.delete('collab');
    window.history.replaceState({}, '', url.toString());
    window.location.href = url.toString();
  }, []);

  return {
    handlePluginActivation,
    isUpdating,
    handleCloseActivationLogin,
    showCollabExperience,
  };
};
